export const initialState = {
  unViewed: 'newLinks',
};
